import { render, staticRenderFns } from "./TranslationsLoader.vue?vue&type=template&id=557f784a&"
import script from "./TranslationsLoader.vue?vue&type=script&lang=js&"
export * from "./TranslationsLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports